import React from "react";

function Singlecomplaint(props) {
  return (
    <div class="container mt-4">
      <div class="card">
        <h5 class="card-header">
          Registered on: {new Date(props.date)?.toDateString()}
        </h5>
        <div class="card-body">
          <h5 class="card-title">Location of complaint: {props.location}</h5>
          <p class="card-text">Type of complaint: {props.type}</p>
        </div>
      </div>
    </div>
  );
}

export default Singlecomplaint;
